// import { useState, useEffect } from "react";
// import axios from "axios";
// import { createPortal } from "react-dom";


// const BASE_URL = "https://ecom.cyberathon.com/index.php/Api/add_registration";

// function Registration({ show, onClose, openLogin }) {
  
// const initialFormState = {
//   full_name: "",
//   email: "",
//   password: "",
//   phone: "",
//   address1: "",
//   country: "",
//   state: "",
//   city: "",
//   pin_code: ""
// };

// const [formData, setFormData] = useState(initialFormState);
// const [errors, setErrors] = useState({});
// const [showPassword, setShowPassword] = useState(false);

//   const addressFields = [
//   { name: "address1", label: "Address" },
//   { name: "country", label: "Country" },
//   { name: "state", label: "State" },
//   { name: "city", label: "City" },
//   { name: "pin_code", label: "Pin Code" }
// ];


//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };
// const validateForm = () => {
//   let newErrors = {};

//   if (!formData.full_name.trim()) {
//   newErrors.full_name = "Full Name is required";
// } 
// else if (!/^[A-Za-z\s]+$/.test(formData.full_name)) {
//   newErrors.full_name = "Full Name should contain only letters";
// }


//   if (!formData.email.trim()) {
//     newErrors.email = "Email is required";
//   } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
//     newErrors.email = "Invalid email format";
//   }

//   if (!formData.password.trim()) {
//   newErrors.password = "Password is required";
// } 
// else if (formData.password.length < 6) {
//   newErrors.password = "Password must be at least 6 characters";
// }

//   if (!formData.phone.trim()) {
//     newErrors.phone = "Phone number is required";
//   } else if (!/^[0-9]{10}$/.test(formData.phone)) {
//     newErrors.phone = "Phone must be 10 digits";
//   }

//   if (!formData.city.trim()) {
//     newErrors.city = "City is required";
//   }

// //   if (!formData.pin_code.trim()) {
// //   newErrors.pin_code = "Pin Code is required";
// // } 
// // else if (!/^[0-9]{6}$/.test(formData.pin_code)) {
// //   newErrors.pin_code = "Pin Code must be exactly 6 digits";
// // }


//   setErrors(newErrors);

//   return Object.keys(newErrors).length === 0;
// };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

   
// if (!validateForm()) return;

//     try {
//       const response = await axios.post(BASE_URL, formData, {
//         headers: { "Content-Type": "application/json" }
//       });

//       console.log("API RESPONSE:", response.data);
//       const res = response.data; 

//       if (res.status === true) {
//         alert("Registration Successful!");
//         setFormData(initialFormState);
//         onClose();
//         openLogin();
//       } else {
//         alert(res.message || "Something went wrong");
//       }
//     } catch (error) {
//       console.error(error);
//       alert("API Error");
//     }
//   };
// useEffect(() => {
//   if (!show) {
//     setFormData(initialFormState);
//   }
// }, [show]);

//   if (!show) return null;

//   return createPortal (
//     <div
//       className="modal fade show d-block mtt"
//       tabIndex="-1"
//       style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//     >
//       <div className="modal-dialog  modal-md">
//         <div className="modal-content ">

//           {/* Header */}
//           <div
//             className="modal-header no-border d-flex flex-column align-items-center position-relative pt-0"
//             style={{ borderBottom: "none" }}
//           >
//             <div className="w-100 d-flex justify-content-between align-items-center p-0">
//               <h3 className="modal-title fw-bold text-center fs-2 pt-0 mt-0">
//                 Sign Up
//               </h3>
//               <button type="button" className="btn-close" onClick={onClose}></button>
//             </div>
//             <p className="mt-1">Please fill in this form to create an account!</p>
//           </div>

//           {/* Body */}
//           <div className="modal-body  pt-0">
//             <form onSubmit={handleSubmit}>
//               {/* Full Name */}
//               <div className="mb-3">
//                 <label className="form-label">Full Name</label>
//                 <input
//                   type="text"
//                   name="full_name"
//                   // className="form-control"
//                    className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
//                   placeholder="Full Name"
//                   value={formData.full_name}
//                   onChange={handleChange}
//                   required
//                 />
//                 {errors.full_name && (
//   <small className="invalid-feedback">{errors.full_name}</small>
// )}
//               </div>

// {/* phone */}
//   <div className="mb-3">
//                 <label className="form-label">Phone</label>
//                 <input
//                   type="tel"
//                   name="phone"
//                  inputMode="numeric"
//                   pattern="[0-9]*"
//                   maxLength="10"
//                 className={`form-control ${errors.phone ? "is-invalid" : ""}`}
//                   placeholder="Phone Number"
//                   value={formData.phone}
//                   onChange={handleChange}
//                 />
//                  {errors.phone && (
//   <small className="invalid-feedback">{errors.phone}</small>
// )}
//               </div>

//               {/* Email */}
//               <div className="mb-3">
//                 <label className="form-label">Email</label>
//                 <input
//                   type="email"
//                   name="email"
//                   // className="form-control"
//                   className={`form-control ${errors.email ? "is-invalid" : ""}`}
//                   placeholder="Enter email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                 />
//                 {errors.email && (
//   <small className="invalid-feedback">{errors.email}</small>
// )}
//               </div>
              


//               {/* Password */}
//              <div className="mb-3">
//   <label className="form-label">Password</label>
//   <input
//     type={showPassword ? "text" : "password"}
//     name="password"
//     className={`form-control ${errors.password ? "is-invalid" : ""}`}
//     placeholder="Enter password"
//     value={formData.password}
//     onChange={handleChange}
//   />
//  <span
//     onClick={() => setShowPassword(!showPassword)}
//     style={{
//       position: "absolute",
//       right: "24px",
//       top: "295px",
//       cursor: "pointer"
//     }}
//   >
// <i className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}></i>  </span>
//   {errors.password && (
//     <small className="invalid-feedback">{errors.password}</small>
//   )}
// </div>

            

// <div className=" mb-3">
//   <label className="form-label">City</label>
//   <input
//     type="text"
//     name="city"
   
//     className={`form-control ${errors.city ? "is-invalid" : ""}`}
//     placeholder="City"
//     value={formData.city}
//     onChange={handleChange}
//   />
//   {errors.city && (
//   <small className="invalid-feedback">{errors.city}</small>
// )}
// </div>

           
//               {/* Address Fields */}
  
// {/* <div className="row">
   
//   <div className=" col-6 col-md-6 mb-3">
//     <label className="form-label">Address</label>
//     <input
//       type="text"
//       name="address1"
//       className="form-control"
//       placeholder="Address"
//       value={formData.address1}
//       onChange={handleChange}
//     />
//   </div>
// <div className="col-6 col-md-6 mb-3">
//                 <label className="form-label">Phone</label>
//                 <input
//                   type="text"
//                   name="phone"
//                   // className="form-control"
//                 className={`form-control ${errors.phone ? "is-invalid" : ""}`}
//                   placeholder="Phone Number"
//                   value={formData.phone}
//                   onChange={handleChange}
//                 />
//                  {errors.phone && (
//   <small className="invalid-feedback">{errors.phone}</small>
// )}
//               </div>
             

// </div>
// <div className="row">
//   <div className="col-6 col-md-6 mb-3">
//     <label className="form-label">Country</label>
//     <input
//       type="text"
//       name="country"
//       className="form-control"
//       placeholder="Country"
//       value={formData.country}
//       onChange={handleChange}
//     />
//   </div>
//   <div className="col-6 col-md-6 mb-3">
//     <label className="form-label">State</label>
//     <input
//       type="text"
//       name="state"
//       className="form-control"
//       placeholder="State"
//       value={formData.state}
//       onChange={handleChange}
//     />
//   </div>
// </div> */}
// {/* State + Pin Code */}
// {/* <div className="row">

// <div className="col-6 col-md-6  mb-3">
//   <label className="form-label">City</label>
//   <input
//     type="text"
//     name="city"
//     // className="form-control"
//     className={`form-control ${errors.city ? "is-invalid" : ""}`}
//     placeholder="City"
//     value={formData.city}
//     onChange={handleChange}
//   />
//   {errors.city && (
//   <small className="invalid-feedback">{errors.city}</small>
// )}
// </div>


//   <div className="col-6 col-md-6 mb-3">
//     <label className="form-label">Pin Code</label>
//     <input
//       type="text"
//       name="pin_code"
//       // className="form-control"
//  className={`form-control ${errors.pin_code ? "is-invalid" : ""}`}
//       placeholder="Pin Code"
//       value={formData.pin_code}
//       onChange={handleChange}
//     />
//     {errors.pin_code && (
//   <small className="invalid-feedback">{errors.pin_code}</small>
// )}
//   </div>
  
// </div> */}




//               {/* Terms & Conditions */}
//               <div className="form-check mb-3">
//                 <input type="checkbox" className="form-check-input" id="remember" required />
//                 <label className="form-check-label" htmlFor="remember">
//                   I agree to the{" "}
//                   <span
//                     className="text-primary text-decoration-underline"
//                     style={{ cursor: "pointer" }}
//                   >
//                     Terms and conditions
//                   </span>
//                 </label>
//               </div>

//               {/* Submit */}
//               <button type="submit" className="border-0 p-2 rounded-1 text-light fw-semibold bg-col w-100">Sign Up</button>

              

//             </form>
//           </div>

//         </div>
//       </div>
     
//     </div>,
//     document.body
    
//   );
// }

// export default Registration;

// import { useState, useEffect } from "react";
// import axios from "axios";
// import { createPortal } from "react-dom";

// const BASE_URL = "https://ecom.cyberathon.com/index.php/Api/add_registration";

// function Registration({ show, onClose, openLogin }) {

//   const initialFormState = {
//     full_name: "",
//     email: "",
//     password: "",
//     phone: "",
//     address1: "",
//     country: "",
//     state: "",
//     city: "",
//     pin_code: ""
//   };

//   const [formData, setFormData] = useState(initialFormState);
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const validateForm = () => {
//     let newErrors = {};

//     if (!formData.full_name.trim()) {
//       newErrors.full_name = "Full Name is required";
//     } else if (!/^[A-Za-z\s]+$/.test(formData.full_name)) {
//       newErrors.full_name = "Full Name should contain only letters";
//     }

//     if (!formData.email.trim()) {
//       newErrors.email = "Email is required";
//     } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
//       newErrors.email = "Invalid email format";
//     }

//     if (!formData.password.trim()) {
//       newErrors.password = "Password is required";
//     } else if (formData.password.length < 6) {
//       newErrors.password = "Password must be at least 6 characters";
//     }

//     if (!formData.phone.trim()) {
//       newErrors.phone = "Phone number is required";
//     } else if (!/^[0-9]{10}$/.test(formData.phone)) {
//       newErrors.phone = "Phone must be 10 digits";
//     }

//     if (!formData.city.trim()) {
//       newErrors.city = "City is required";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     try {
//       const response = await axios.post(BASE_URL, formData, {
//         headers: { "Content-Type": "application/json" }
//       });

//       console.log("API RESPONSE:", response.data);
//       const res = response.data;

//       if (res.status === true) {
//         alert("Registration Successful!");
//         setFormData(initialFormState);
//         onClose();
//         openLogin();
//       } else {
//         alert(res.message || "Something went wrong");
//       }
//     } catch (error) {
//       console.error(error);
//       alert("API Error");
//     }
//   };

//   useEffect(() => {
//     if (!show) {
//       setFormData(initialFormState);
//     }
//   }, [show]);

//   if (!show) return null;

//   return createPortal(
//     <div
//       className="modal fade show d-block mtt"
//       tabIndex="-1"
//       style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//     >
//       <div className="modal-dialog modal-md">
//         <div className="modal-content">

//           {/* Header */}
//           <div
//             className="modal-header no-border d-flex flex-column align-items-center position-relative pt-0"
//             style={{ borderBottom: "none" }}
//           >
//             <div className="w-100 d-flex justify-content-between align-items-center p-0">
//               <h3 className="modal-title fw-bold text-center fs-2 pt-0 mt-0">
//                 Sign Up
//               </h3>
//               <button type="button" className="btn-close" onClick={onClose}></button>
//             </div>
//             <p className="mt-1">Please fill in this form to create an account!</p>
//           </div>

//           {/* Body */}
//           <div className="modal-body pt-0">
//             <form onSubmit={handleSubmit}>

//               {/* Full Name */}
//               <div className="mb-3">
//                 <label className="form-label">Full Name</label>
//                 <input
//                   type="text"
//                   name="full_name"
//                   className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
//                   placeholder="Full Name"
//                   value={formData.full_name}
//                   onChange={handleChange}
//                   required
//                 />
//                 {errors.full_name && (
//                   <small className="invalid-feedback">{errors.full_name}</small>
//                 )}
//               </div>

//               {/* Phone */}
//               <div className="mb-3">
//                 <label className="form-label">Phone</label>
//                 <input
//                   type="tel"
//                   name="phone"
//                   inputMode="numeric"
//                   pattern="[0-9]*"
//                   maxLength="10"
//                   className={`form-control ${errors.phone ? "is-invalid" : ""}`}
//                   placeholder="Phone Number"
//                   value={formData.phone}
//                   onChange={handleChange}
//                 />
//                 {errors.phone && (
//                   <small className="invalid-feedback">{errors.phone}</small>
//                 )}
//               </div>

//               {/* Email */}
//               <div className="mb-3">
//                 <label className="form-label">Email</label>
//                 <input
//                   type="email"
//                   name="email"
//                   className={`form-control ${errors.email ? "is-invalid" : ""}`}
//                   placeholder="Enter email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                 />
//                 {errors.email && (
//                   <small className="invalid-feedback">{errors.email}</small>
//                 )}
//               </div>

//               {/* Password — fixed eye icon */}
//               <div className="mb-3">
//                 <label className="form-label">Password</label>
//                 {/* ✅ position-relative on wrapper so eye stays inside input on ALL screen sizes */}
//                 <div className="position-relative">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     name="password"
//                     className={`form-control ${errors.password ? "is-invalid" : ""}`}
//                     placeholder="Enter password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     style={{ paddingRight: "42px" }}
//                   />
//                   {/* Eye icon — always right-aligned inside input */}
//                   <span
//                     onClick={() => setShowPassword(!showPassword)}
//                     style={{
//                       position: "absolute",
//                       right: "12px",
//                       top: "50%",
//                       transform: "translateY(-50%)",
//                       cursor: "pointer",
//                       zIndex: 5,
//                       color: "#6c757d",
//                       lineHeight: 1,
//                     }}
//                   >
//                     <i className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}></i>
//                   </span>
//                   {errors.password && (
//                     <small className="invalid-feedback d-block">{errors.password}</small>
//                   )}
//                 </div>
//               </div>

//               {/* City */}
//               <div className="mb-3">
//                 <label className="form-label">City</label>
//                 <input
//                   type="text"
//                   name="city"
//                   className={`form-control ${errors.city ? "is-invalid" : ""}`}
//                   placeholder="City"
//                   value={formData.city}
//                   onChange={handleChange}
//                 />
//                 {errors.city && (
//                   <small className="invalid-feedback">{errors.city}</small>
//                 )}
//               </div>

//               {/* Terms & Conditions */}
//               <div className="form-check mb-3">
//                 <input type="checkbox" className="form-check-input" id="remember" required />
//                 <label className="form-check-label" htmlFor="remember">
//                   I agree to the{" "}
//                   <span
//                     className="text-primary text-decoration-underline"
//                     style={{ cursor: "pointer" }}
//                   >
//                     Terms and conditions
//                   </span>
//                 </label>
//               </div>

//               {/* Submit */}
//               <button
//                 type="submit"
//                 className="border-0 p-2 rounded-1 text-light fw-semibold bg-col w-100"
//               >
//                 Sign Up
//               </button>

//             </form>
//           </div>

//         </div>
//       </div>
//     </div>,
//     document.body
//   );
// }

// export default Registration;



import { useState, useEffect } from "react";
import axios from "axios";
import { createPortal } from "react-dom";

const BASE_URL = "https://ecom.cyberathon.com/index.php/Api/add_registration";

function Registration({ show, onClose, openLogin }) {

  const initialFormState = {
    full_name: "",
   
    password: "",
   contact: "",
    address1: "",
    country: "",
    state: "",
    city: "",
    pin_code: ""
  };

  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.full_name.trim()) {
      newErrors.full_name = "Full Name is required";
    } else if (!/^[A-Za-z\s]+$/.test(formData.full_name)) {
      newErrors.full_name = "Full Name should contain only letters";
    }

    // if (!formData.email.trim()) {
    //   newErrors.email = "Email is required";
    // } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
    //   newErrors.email = "Invalid email format";
    // }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    // if (!formData.phone.trim()) {
    //   newErrors.phone = "Phone number is required";
    // } else if (!/^[0-9]{10}$/.test(formData.phone)) {
    //   newErrors.phone = "Phone must be 10 digits";
    // }
    if(!formData.contact.trim()){
      newErrors.contact = "Mobile or Email is required";
    }else if (
  !/^\S+@\S+\.\S+$/.test(formData.contact) &&   // email check
  !/^[0-9]{10}$/.test(formData.contact)         // phone check
) {
  newErrors.contact = "Enter valid email or 10 digit phone";
}

    if (!formData.city.trim()) {
      newErrors.city = "City is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const payload = {
        ...formData,
        email:/^\S+@\S+.\S+$/.test(formData.contact)
        ? formData.contact
        : "",
        phone:/^[0-9]{10}$/.test(formData.contact)
        ? formData.contact
        : ""
      }
      const response = await axios.post(BASE_URL, payload, {
        headers: { "Content-Type": "application/json" }
      });

      console.log("API RESPONSE:", response.data);
      const res = response.data;

      if (res.status === true) {
        alert("Registration Successful!");
        setFormData(initialFormState);
        onClose();
        openLogin();
      } else {
        alert(res.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
      alert("API Error");
    }
  };

  useEffect(() => {
    if (!show) {
      setFormData(initialFormState);
    }
  }, [show]);

  if (!show) return null;

  return createPortal(
    <div
      className="modal fade show d-block mtt"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-md">
        <div className="modal-content">

          {/* Header */}
          <div
            className="modal-header no-border d-flex flex-column align-items-center position-relative pt-0"
            style={{ borderBottom: "none" }}
          >
            <div className="w-100 d-flex justify-content-between align-items-center p-0">
              <h3 className="modal-title fw-bold text-center fs-2 pt-0 mt-0">
                Sign Up
              </h3>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <p className="mt-1">Please fill in this form to create an account!</p>
          </div>

          {/* Body */}
          <div className="modal-body pt-0">
            <form onSubmit={handleSubmit}>

              {/* Full Name */}
              <div className="mb-3">
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  name="full_name"
                  className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
                  placeholder="Full Name"
                  value={formData.full_name}
                  onChange={handleChange}
                  required
                />
                {errors.full_name && (
                  <small className="invalid-feedback">{errors.full_name}</small>
                )}
              </div>

              {/* Phone */}
              {/* <div className="mb-3">
                <label className="form-label">Phone</label>
                <input
                  type="tel"
                  name="phone"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength="10"
                  className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {errors.phone && (
                  <small className="invalid-feedback">{errors.phone}</small>
                )}
              </div> */}

              {/* Email */}
              {/* <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  placeholder="Enter email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {errors.email && (
                  <small className="invalid-feedback">{errors.email}</small>
                )}
              </div> */}
{/* Mobile or Email */}
<div className="mb-3">
  <label className="form-label">Mobile or Email</label>

  <input
    type="text"
    name="contact"
    className={`form-control ${errors.contact ? "is-invalid" : ""}`}
    placeholder="Enter Mobile or Email"
    value={formData.contact}
    onChange={handleChange}
  />

  {errors.contact && (
    <small className="invalid-feedback">
      {errors.contact}
    </small>
  )}
</div>
              {/* Password — fixed eye icon */}
              <div className="mb-3">
                <label className="form-label">Password</label>
                {/* ✅ position-relative on wrapper so eye stays inside input on ALL screen sizes */}
                <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className={`form-control ${errors.password ? "is-invalid" : ""}`}
                    placeholder="Enter password"
                    value={formData.password}
                    onChange={handleChange}
                    style={{ paddingRight: "42px" }}
                  />
                  {/* Eye icon — always right-aligned inside input */}
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      zIndex: 5,
                      color: "#6c757d",
                      lineHeight: 1,
                    }}
                  >
                    <i className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"}`}></i>
                  </span>
                  {errors.password && (
                    <small className="invalid-feedback d-block">{errors.password}</small>
                  )}
                </div>
              </div>

              {/* City */}
              <div className="mb-3">
                <label className="form-label">City</label>
                <input
                  type="text"
                  name="city"
                  className={`form-control ${errors.city ? "is-invalid" : ""}`}
                  placeholder="City"
                  value={formData.city}
                  onChange={handleChange}
                />
                {errors.city && (
                  <small className="invalid-feedback">{errors.city}</small>
                )}
              </div>

              {/* Terms & Conditions */}
              <div className="form-check mb-3">
                <input type="checkbox" className="form-check-input" id="remember" required />
                <label className="form-check-label" htmlFor="remember">
                  I agree to the{" "}
                  <span
                    className="text-primary text-decoration-underline"
                    style={{ cursor: "pointer" }}
                  >
                    Terms and conditions
                  </span>
                </label>
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="border-0 p-2 rounded-1 text-light fw-semibold bg-col w-100"
              >
                Sign Up
              </button>

            </form>
          </div>

        </div>
      </div>
    </div>,
    document.body
  );
}

export default Registration;